import React from 'react';
import axios from 'axios';
import qs from 'qs';

import { Dropdown, Input, Icon, Button, Popup, Menu, Divider, Label } from 'semantic-ui-react';

import _ from 'lodash';
import moment from 'moment';

import { fetch_unique_multiselect_filter_opts } from '../Utility/DataSources';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
/*
* Component Props
- selectedOps
- onChange
- trigger
- data
- field
*/
export class DateFilter extends React.PureComponent {
  handleSelectionChange = (field) => (date, evt) => {
    //evt.stopPropagation();
    //console.log(evt);
    var onChange = this.props.onChange(this.props.field, this.props.filterType) || function() {};

    const prevSelectedOpts = this.props.selectedOpts || { startDate: null, endDate: null };
    const newValue = {
      [field]: moment(date || null).isValid() ? moment(date).format('YYYY-MM-DD') : null,
    };

    onChange({ ...prevSelectedOpts, ...newValue });
  };

  render() {
    const selectedOpts = this.props.selectedOpts || { startDate: null, endDate: null };

    const isFiltered =
      moment(selectedOpts.startDate || null).isValid() || moment(selectedOpts.endDate || null).isValid();
    const trigger = (
      <span onClick={(e) => e.stopPropagation()}>
        {isFiltered ? (
          <Icon.Group>
            <Icon name="filter" color="blue" />
            <Icon corner name="asterisk" color="blue" />
          </Icon.Group>
        ) : (
          <Icon name="filter" />
        )}
      </span>
    );

    return (
      <Popup
        trigger={trigger}
        on="click"
        position="bottom center"
        className="DateFilterDropdown"
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ width: 275 }} onClick={(e) => e.stopPropagation()}>
          {/*<Input
            onClick={(e) => e.stopPropagation()}
            icon="calendar alternate outline"
            label={{ content: 'From:', color: 'blue' }}
            labelPosition="left"
            type="date"
            fluid
            style={{ cursor: 'pointer' }}
            value={selectedOpts.startDate || ''}
            onChange={this.handleSelectionChange('startDate')}
            onKeyDown={(e) => {
              //prevent manual entry
              e.preventDefault();
            }}
          />
          <Divider />
          <Input
            onClick={(e) => e.stopPropagation()}
            icon="calendar alternate outline"
            label={{ content: 'To:', color: 'blue' }}
            labelPosition="left"
            type="date"
            fluid
            style={{ cursor: 'pointer' }}
            value={selectedOpts.endDate || ''}
            onChange={this.handleSelectionChange('endDate')}
            onKeyDown={(e) => {
              //prevent manual entry
              e.preventDefault();
            }}
          />*/}
          <DatePicker
            selected={moment(selectedOpts.startDate || null).isValid() ? moment(selectedOpts.startDate) : null}
            onChange={this.handleSelectionChange('startDate')}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            placeholderText="Any Date"
            dateFormat="DD/MMM/YYYY"
            onClick={(e) => e.stopPropagation()}
            customInput={
              <Input
                onClick={(e) => e.stopPropagation()}
                action={{
                  icon: 'close',
                  color: 'red',
                  onClick: () => {
                    this.handleSelectionChange('startDate')(null);
                  },
                }}
                label={<Label content="From:" color="blue" icon="calendar alternate outline" />}
                labelPosition="left"
                style={{ cursor: 'pointer' }}
              />
            }
          />

          <Divider />

          <DatePicker
            selected={moment(selectedOpts.endDate || null).isValid() ? moment(selectedOpts.endDate) : null}
            onChange={this.handleSelectionChange('endDate')}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            placeholderText="Any Date"
            dateFormat="DD/MMM/YYYY"
            onClick={(e) => e.stopPropagation()}
            customInput={
              <Input
                onClick={(e) => e.stopPropagation()}
                action={{
                  icon: 'close',
                  color: 'red',
                  onClick: () => {
                    this.handleSelectionChange('endDate')(null);
                  },
                }}
                label={<Label content="To:" color="blue" icon="calendar alternate outline" />}
                labelPosition="left"
                style={{ cursor: 'pointer' }}
              />
            }
          />
        </div>
      </Popup>
    );
  }
}

export class RemoteMultiFilterDropdown extends React.PureComponent {
  state = { search: '', selectedOpts: [] };

  handleSearchChange = (evt, data) => this.setState({ search: data.value });

  handleSelectionChange = (evt, data) => {
    evt.stopPropagation();

    var onChange = this.props.onChange(this.props.field, this.props.filterType) || function() {};

    var isSelected = _.includes(this.props.selectedOpts, data.value);

    var newSelectedOpts;
    if (isSelected) {
      newSelectedOpts = _.filter(this.props.selectedOpts, function(opt) {
        return opt !== data.value;
      });
    } else {
      newSelectedOpts = _.concat(this.props.selectedOpts, data.value);
    }

    onChange(newSelectedOpts);
  };

  handleClearAll = (evt) => {
    evt.stopPropagation();

    var onChange = this.props.onChange(this.props.field, this.props.filterType) || function() {};
    onChange([]);
  };

  getRemoteOptions = () => {
    if (_.isUndefined(this.props.field)) {
      return;
    }
    const comp = this;
    comp.setState({ fetchingRemoteOpts: true });

    axios
      .request({
        url: fetch_unique_multiselect_filter_opts,
        method: 'get',
        params: {
          field: this.props.field,
          table: this.props.table,
          token: this.props.authorization.access_token,
        },
      })
      .then(function(response) {
        var data = _.sortBy(response.data);

        comp.setState({
          fetchingRemoteOpts: false,
          remoteOptions: data,
        });
      })
      .catch(function(error) {
        comp.setState({ fetchingRemoteOpts: false });
      });
  };

  clearRemoteOptions = () => {
    this.setState({
      remoteOptions: [],
      search: '',
    });
  };

  //componentDidMount = () => {
  //  this.getRemoteOptions();
  //};

  render() {
    const component = this;
    const resultsLimit = 50;

    const remoteFilteredOpts = _.filter(this.state.remoteOptions, function (
      option
    ) {
      return (
        _.includes(
          _.lowerCase(_.trim(option)),
          _.lowerCase(_.trim(component.state.search))
        ) || _.includes(component.props.selectedOpts, option)
      ); //always show selected opts...
    });

    const trigger = this.props.trigger || <Icon name="filter" />;
    //pointing="right"
    const resultsList = _.map(
      remoteFilteredOpts.slice(0, resultsLimit),
      function (opt, idx) {
        return (
          <Dropdown.Item
            key={idx}
            value={opt}
            onClick={component.handleSelectionChange}
          >
            {_.includes(component.props.selectedOpts, opt) && (
              <Icon color="green" name="checkmark" />
            )}
            {opt}
          </Dropdown.Item>
        );
      }
    );
    return (
      <Dropdown
        multiple
        trigger={trigger}
        icon={null}
        compact
        item
        closeOnChange={false}
        loading={this.state.fetchingRemoteOpts}
        onOpen={this.getRemoteOptions}
        onClose={this.clearRemoteOptions}
        pointing={this.props.pointing || false}
      >
        <Dropdown.Menu>
          <Input
            icon="search"
            iconPosition="left"
            className="search"
            placeholder="search"
            value={this.state.search}
            onChange={component.handleSearchChange}
            onClick={(e) => e.stopPropagation()}
          />

          <Dropdown.Menu scrolling style={{ maxWidth: '25vw' }}>
            {!this.state.search && remoteFilteredOpts.length > resultsLimit
              ? _.map(component.props.selectedOpts, function (opt, idx) {
                return (
                  <Dropdown.Item
                    key={idx}
                    value={opt}
                    onClick={component.handleSelectionChange}
                  >
                    <Icon color="green" name="checkmark" />
                    {opt}
                  </Dropdown.Item>
                );
              })
              : resultsList}
          </Dropdown.Menu>

          {!this.state.search && remoteFilteredOpts.length > resultsLimit ? (
            <div style={{ textAlign: 'center', marginTop: '15px' }}>
              {'start searching'}
              <br />
              {'to see potential filters'}
            </div>
          ) : remoteFilteredOpts.length > resultsLimit ? (
            <div
              style={{ textAlign: 'center' }}
            >{`showing first ${resultsLimit} of ${remoteFilteredOpts.length} results`}</div>
          ) : null}

          <Button.Group fluid widths={2} style={{ marginTop: '15px' }}>
            <Button negative onClick={component.handleClearAll}>
              Clear
            </Button>
          </Button.Group>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const unfilteredIcon = <Icon name="filter" />;
//need to wrap in <i className='icon></i> due to css bug in semantic...
const filteredIcon = (
  <i className="icon">
    <Icon.Group>
      <Icon name="filter" color="blue" />
      <Icon corner name="asterisk" color="blue" />
    </Icon.Group>
  </i>
);
const emptyArr = [];
export class ReporterFilterMenu extends React.PureComponent {
  render() {
    const selectedFirstNames = _.get(this.props.filters, 'FIRST_NAME.value') || emptyArr;
    const selectedLastNames = _.get(this.props.filters, 'LAST_NAME.value') || emptyArr;
    const selectedPhoneNums = _.get(this.props.filters, 'PHONE_NO.value') || emptyArr;
    const selectedEmails = _.get(this.props.filters, 'EMAIL_ID.value') || emptyArr;
    const selectedDepartments = _.get(this.props.filters, 'DEPARTMENT.value') || emptyArr;
    const selectedHospitals = _.get(this.props.filters, 'HOSP_NAME.value') || emptyArr;
    const selectedStates = _.get(this.props.filters, 'STATE.value') || emptyArr;
    const selectedCities = _.get(this.props.filters, 'CITY.value') || emptyArr;
    const selectedCountries = _.get(this.props.filters, 'COUNTRY.value') || emptyArr;
    const selectedPostalCodes = _.get(this.props.filters, 'POSTAL_CODE.value') || emptyArr;

    const filterActive =
      selectedFirstNames.length > 0 ||
      selectedLastNames.length > 0 ||
      selectedPhoneNums.length > 0 ||
      selectedEmails.length > 0 ||
      selectedDepartments.length > 0 ||
      selectedHospitals.length > 0 ||
      selectedStates.length > 0 ||
      selectedCities.length > 0 ||
      selectedCountries.length > 0 ||
      selectedPostalCodes.length > 0;

    const trigger = <span>{filterActive ? filteredIcon : unfilteredIcon}</span>;

    return (
      <Popup trigger={trigger} on="click" position="bottom center">
        <Menu vertical>
          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedFirstNames}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedFirstNames || []).length > 0 ? filteredIcon : unfilteredIcon}
                First Name
              </Menu.Item>
            }
            field="FIRST_NAME"
            table="REPORTERS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedLastNames}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedLastNames || []).length > 0 ? filteredIcon : unfilteredIcon}
                Last Name
              </Menu.Item>
            }
            field="LAST_NAME"
            table="REPORTERS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedPhoneNums}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedPhoneNums || []).length > 0 ? filteredIcon : unfilteredIcon}
                Phone Number
              </Menu.Item>
            }
            field="PHONE_NO"
            table="REPORTERS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedEmails}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedEmails || []).length > 0 ? filteredIcon : unfilteredIcon}
                Email
              </Menu.Item>
            }
            field="EMAIL_ID"
            table="REPORTERS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedDepartments}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedDepartments || []).length > 0 ? filteredIcon : unfilteredIcon}
                Department
              </Menu.Item>
            }
            field="DEPARTMENT"
            table="REPORTERS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedHospitals}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedHospitals || []).length > 0 ? filteredIcon : unfilteredIcon}
                Hospital
              </Menu.Item>
            }
            field="HOSP_NAME"
            table="REPORTERS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedStates}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedStates || []).length > 0 ? filteredIcon : unfilteredIcon}
                State
              </Menu.Item>
            }
            field="STATE"
            table="REPORTERS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedCities}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedCities || []).length > 0 ? filteredIcon : unfilteredIcon}
                City
              </Menu.Item>
            }
            field="CITY"
            table="REPORTERS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedCountries}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedCountries || []).length > 0 ? filteredIcon : unfilteredIcon}
                Country
              </Menu.Item>
            }
            field="COUNTRY"
            table="REPORTERS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedPostalCodes}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedPostalCodes || []).length > 0 ? filteredIcon : unfilteredIcon}
                Postal Code
              </Menu.Item>
            }
            field="POSTAL_CODE"
            table="REPORTERS"
            filterType={this.props.filterType}
          />
        </Menu>
      </Popup>
    );
  }
}

export class ProductFilterMenu extends React.PureComponent {
  render() {
    const selectedTradeName = _.get(this.props.filters, 'TRADE_NAME.value') || emptyArr;
    const selectedProductFlag = _.get(this.props.filters, 'PRODUCT_FLAG.value') || emptyArr;

    const filterActive = selectedTradeName.length > 0 || selectedProductFlag.length > 0;

    const trigger = <span>{filterActive ? filteredIcon : unfilteredIcon}</span>;

    return (
      <Popup trigger={trigger} on="click" position="bottom center">
        <Menu vertical>
          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedTradeName}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedTradeName || []).length > 0 ? filteredIcon : unfilteredIcon}
                Trade Name
              </Menu.Item>
            }
            field="TRADE_NAME"
            table="PRODUCTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedProductFlag}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedProductFlag || []).length > 0 ? filteredIcon : unfilteredIcon}
                Product Flag
              </Menu.Item>
            }
            field="PRODUCT_FLAG"
            table="PRODUCTS"
            filterType={this.props.filterType}
          />
        </Menu>
      </Popup>
    );
  }
}

export class AdverseEventFilterMenu extends React.PureComponent {
  render() {
    const selectedReportedTerm = _.get(this.props.filters, 'REPORTED_TERM.value') || emptyArr;
    //const selectedOnsetDate = _.get(this.props.filters, 'ONSET_DATE.value') || emptyArr;
    //const selectedCessationDate = _.get(this.props.filters, 'CESSATION_DATE.value') || emptyArr;
    const selectedOutcome = _.get(this.props.filters, 'OUTCOME.value') || emptyArr;
    const selectedSeriousness = _.get(this.props.filters, 'SERIOUSNESS.value') || emptyArr;
    const selectedCongenitalAnomaly = _.get(this.props.filters, 'CONGENITAL_ANOMALY.value') || emptyArr;
    const selectedDeath = _.get(this.props.filters, 'DEATH.value') || emptyArr;
    const selectedDisability = _.get(this.props.filters, 'DISABILITY.value') || emptyArr;
    const selectedHospProlonged = _.get(this.props.filters, 'HOSP_PROLONGED.value') || emptyArr;
    const selectedHospRequired = _.get(this.props.filters, 'HOSP_REQUIRED.value') || emptyArr;
    const selectedLifeThreatening = _.get(this.props.filters, 'LIFE_THREATENING.value') || emptyArr;
    const selectedOtherCond = _.get(this.props.filters, 'OTHER_MEDICALLY_IMP_COND.value') || emptyArr;

    const filterActive =
      selectedReportedTerm.length > 0 ||
      //selectedOnsetDate.length > 0 ||
      //selectedCessationDate.length > 0 ||
      selectedOutcome.length > 0 ||
      selectedSeriousness.length > 0 ||
      selectedCongenitalAnomaly.length > 0 ||
      selectedDeath.length > 0 ||
      selectedDisability.length > 0 ||
      selectedHospProlonged.length > 0 ||
      selectedHospRequired.length > 0 ||
      selectedLifeThreatening.length > 0 ||
      selectedOtherCond.length > 0;

    const trigger = <span>{filterActive ? filteredIcon : unfilteredIcon}</span>;

    return (
      <Popup trigger={trigger} on="click" position="bottom center">
        <Menu vertical>
          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedReportedTerm}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedReportedTerm || []).length > 0 ? filteredIcon : unfilteredIcon}
                Reported Term
              </Menu.Item>
            }
            field="REPORTED_TERM"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedOutcome}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedOutcome || []).length > 0 ? filteredIcon : unfilteredIcon}
                AE Outcome
              </Menu.Item>
            }
            field="OUTCOME"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedSeriousness}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedSeriousness || []).length > 0 ? filteredIcon : unfilteredIcon}
                AE Seriousness
              </Menu.Item>
            }
            field="SERIOUSNESS"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedCongenitalAnomaly}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedCongenitalAnomaly || []).length > 0 ? filteredIcon : unfilteredIcon}
                Congenital Anomaly/Birth Defect?
              </Menu.Item>
            }
            field="CONGENITAL_ANOMALY"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedDeath}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedDeath || []).length > 0 ? filteredIcon : unfilteredIcon}
                Death?
              </Menu.Item>
            }
            field="DEATH"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedDisability}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedDisability || []).length > 0 ? filteredIcon : unfilteredIcon}
                Disability or Permanent Damage?
              </Menu.Item>
            }
            field="DISABILITY"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedHospProlonged}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedHospProlonged || []).length > 0 ? filteredIcon : unfilteredIcon}
                Hospitalization Prolonged?
              </Menu.Item>
            }
            field="HOSP_PROLONGED"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedHospRequired}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedHospRequired || []).length > 0 ? filteredIcon : unfilteredIcon}
                Hospitalization New?
              </Menu.Item>
            }
            field="HOSP_REQUIRED"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedLifeThreatening}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedLifeThreatening || []).length > 0 ? filteredIcon : unfilteredIcon}
                Life Threatening?
              </Menu.Item>
            }
            field="LIFE_THREATENING"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedOtherCond}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedOtherCond || []).length > 0 ? filteredIcon : unfilteredIcon}
                Other Serious (Important Medical Events)
              </Menu.Item>
            }
            field="OTHER_MEDICALLY_IMP_COND"
            table="ADVERSE_EVENTS"
            filterType={this.props.filterType}
          />
        </Menu>
      </Popup>
    );
  }
}

export class SourceFilterMenu extends React.PureComponent {
  render() {
    const selectedSource = _.get(this.props.filters, 'SOURCE.value') || emptyArr;
    const selectedAffiliateLoc = _.get(this.props.filters, 'AFFILIATE_LOCATION.value') || emptyArr;
    const selectedAffiliateXrefNum = _.get(this.props.filters, 'AFFILIATE_XREF_NUMBER.value') || emptyArr;
    const selectedIDNum = _.get(this.props.filters, 'IDENTIFICATION_NUMBER.value') || emptyArr;

    const filterActive =
      selectedSource.length > 0 ||
      selectedAffiliateLoc.length > 0 ||
      selectedAffiliateXrefNum.length > 0 ||
      selectedIDNum.length > 0;

    const trigger = <span>{filterActive ? filteredIcon : unfilteredIcon}</span>;

    return (
      <Popup trigger={trigger} on="click" position="bottom center">
        <Menu vertical>
          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedSource}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedSource || []).length > 0 ? filteredIcon : unfilteredIcon}
                Source
              </Menu.Item>
            }
            field="SOURCE"
            table="SOURCES"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedAffiliateLoc}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedAffiliateLoc || []).length > 0 ? filteredIcon : unfilteredIcon}
                Affiliate Location
              </Menu.Item>
            }
            field="AFFILIATE_LOCATION"
            table="SOURCES"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedAffiliateXrefNum}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedAffiliateXrefNum || []).length > 0 ? filteredIcon : unfilteredIcon}
                Affiliate Cross Reference Number
              </Menu.Item>
            }
            field="AFFILIATE_XREF_NUMBER"
            table="SOURCES"
            filterType={this.props.filterType}
          />

          <RemoteMultiFilterDropdown
            authorization={this.props.authorization}
            pointing="right"
            selectedOpts={selectedIDNum}
            onChange={this.props.onChange}
            trigger={
              <Menu.Item>
                {(selectedIDNum || []).length > 0 ? filteredIcon : unfilteredIcon}
                Source Reference Number
              </Menu.Item>
            }
            field="IDENTIFICATION_NUMBER"
            table="SOURCES"
            filterType={this.props.filterType}
          />
        </Menu>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/FilterDropdowns.js